import React from "react";
import Typography from "@mui/material/Typography";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import {
  DateRangePicker,
  DateRangePickerProps,
} from "@mui/x-date-pickers-pro/DateRangePicker";
import { LocalizationProvider } from "@mui/x-date-pickers-pro/LocalizationProvider";
import {
  MultiInputDateRangeField,
  MultiInputDateRangeFieldProps,
} from "@mui/x-date-pickers-pro/MultiInputDateRangeField";

import SVG from "@/assets/svg";
import { DEFAULT_DATE_FORMAT } from "@/utils/constants";

import "@/utils/dayjs-config";

const CustomMultiInputDateRangeField = React.forwardRef<
  HTMLDivElement,
  MultiInputDateRangeFieldProps
>((props, ref) => (
  <MultiInputDateRangeField
    {...props}
    ref={ref}
    slotProps={{
      separator: { children: <Typography>To</Typography> },
      textField: {
        slotProps: {
          input: {
            endAdornment: <SVG.Date width={25} height={25} />,
          },
        },
      },
    }}
  />
));

CustomMultiInputDateRangeField.displayName = "CustomMultiInputDateRangeField";
(
  CustomMultiInputDateRangeField as typeof CustomMultiInputDateRangeField & {
    fieldType?: string;
  }
).fieldType = "multi-input";

const DateRangePickerComponent: React.FC<DateRangePickerProps> = (props) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateRangePicker
        slots={{
          field: CustomMultiInputDateRangeField,
        }}
        format={DEFAULT_DATE_FORMAT}
        timezone="UTC"
        label=""
        localeText={{ start: "", end: "" }}
        {...props}
      />
    </LocalizationProvider>
  );
};

export default DateRangePickerComponent;
